(function ($) {
    $(document).ready(function () {
        $('#pay-online-banner').css('cursor', 'pointer');
        $('#pay-online-banner').click(function () {
            if (App.cookie.get('SID') !== undefined) {
                window.location = 'http://www.escc.ru/for-students/fininfo';
            } else {
                window.location = 'http://www.escc.ru/login';
            }
        });
    });
})(jQuery);